export const VIEW_TOOLTIP_KEY = 'viewAngleTooltip'
export const HOTSPOT_TOOLTIP_KEY = 'hotspotTooltip'
